import { render, staticRenderFns } from "./Avv.vue?vue&type=template&id=3cf420f0&scoped=true&"
import script from "./Avv.vue?vue&type=script&lang=js&"
export * from "./Avv.vue?vue&type=script&lang=js&"
import style0 from "./Avv.vue?vue&type=style&index=0&id=3cf420f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf420f0",
  null
  
)

export default component.exports